import { Flex } from '@chakra-ui/react';
import { SidebarLayout } from 'src/layouts/SidebarLayout';
import { RevisionSidebar } from '../SubmissionUpload/RevisionSidebar';
import { IRevisionRound } from '@publishing-engine/domain/models';
import StepHeader from '../SubmissionUpload/components/StepHeader';
import RevisionRequest from './RevisionRequest';
import { PreferencesTab } from 'src/components/Submission/MySubmission/PreferencesTab';
import { UnsubmitFeedbackAccordion } from 'src/components/Submission/MySubmission/components/feedback/UnsubmitFeedbackAccordion';
import { Button } from '@morressier/alembic';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faChevronLeft,
  faChevronRight
} from '@fortawesome/pro-regular-svg-icons';

interface Props {
  currentStep: number;
  totalSteps: number;
  goToPreviousStep: () => void;
  goToNextStep: () => void;
  goToStep: (step: number) => void;
  onClose: () => void;
  revisionRound: IRevisionRound | undefined;
}

const SubmissionPreferencesStep: React.FC<Props> = ({
  currentStep,
  goToStep,
  totalSteps,
  onClose,
  revisionRound,
  goToNextStep,
  goToPreviousStep
}) => {

  return (
    <>
      <Flex
        flexDirection="column"
        backgroundColor="surfaceSecondaryFill"
        minH="100vh"
      >
        <SidebarLayout
          sidebar={
            <RevisionSidebar
              currentStep={currentStep}
              onNavigate={step => {
                goToStep(step);
              }}
            />
          }
        >
          <StepHeader
            currentStep={currentStep + 1}
            totalSteps={totalSteps}
            heading="Select Submission Preferences"
            description={
              'Select the following preferences to tailor how your manuscript is processed and published.'
            }
          />
          <UnsubmitFeedbackAccordion />
          {revisionRound && <RevisionRequest revisionRound={revisionRound} />}
          <PreferencesTab showTitle={false} isUpdateRequired />
        </SidebarLayout>
      </Flex>
      <Flex
        padding={4}
        bottom={0}
        zIndex={1}
        justifyContent="center"
        position="sticky"
        bgColor="surfacePrimaryFill"
        marginX="auto"
      >
        <Flex width="100%" justifyContent="space-between">
          {/* ----- Footer Buttons ----- */}
          <Button
            variant="caution"
            onClick={() => {
              onClose();
            }}
          >
            Exit
          </Button>
          <Flex gap={4} flexDirection="row">
            <Button
              variant="secondary"
              leftIcon={<FontAwesomeIcon icon={faChevronLeft} />}
              onClick={goToPreviousStep}
            >
              Back
            </Button>
            <Button variant="primary" onClick={goToNextStep}>
              Next
              <FontAwesomeIcon icon={faChevronRight} />
            </Button>
          </Flex>
        </Flex>
      </Flex>
    </>
  );
};

export default SubmissionPreferencesStep;
